import { z } from 'zod';
/** Uniform API error body: the server replies `{ error: <Romanian string> }`. */
export const apiErrorSchema = z.object({ error: z.string() });
export const loginSchema = z.object({
    email: z.string().trim().min(1, 'Introduceți adresa de email').email('Adresă de email invalidă'),
    password: z.string().min(1, 'Introduceți parola'),
});
export const invitationAcceptSchema = z
    .object({
    name: z.string().trim().min(1, 'Introduceți numele'),
    password: z.string().min(8, 'Parola trebuie să aibă cel puțin 8 caractere'),
    confirmPassword: z.string(),
})
    .refine((v) => v.password === v.confirmPassword, {
    message: 'Parolele nu coincid',
    path: ['confirmPassword'],
});
/** Shape of GET /me — the single source of org/role context for the shell + guards. */
export const meResponseSchema = z.object({
    userId: z.string(),
    email: z.string(),
    orgId: z.string(),
    orgName: z.string(),
    orgRole: z.enum(['owner', 'admin', 'member']),
    permissions: z.array(z.string()),
    globalRole: z.enum(['platform_admin', 'user']),
});
